export default "__VITE_ASSET__D1l17xEv__"